// @flow

export const formatTelNo = (tel: string): string => tel.replace(/\s/g, '');
